import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './utils/consoleOverride'; // Import console override to control debug logging

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Disabling StrictMode to prevent WebSocket connection issues in development
// This solves the "websocket disconnect" issue when sending text messages
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);
